export default __webpack_public_path__ + "static/media/km.f6652e5b.svg";